import app from 'app';
import _ from 'lodash-extended';

export default class TextOverlayEffectController {
  static handleAssetSplit({ originalAsset, cloneAsset, assetSplitTimes }) {
    const leftTextOverlays =
      originalAsset.agd && originalAsset.agd.textOverlays;
    const rightTextOverlays = cloneAsset.agd && cloneAsset.agd.textOverlays;

    _.each(leftTextOverlays, (left, n) => {
      // manage left and right text overlays
      const right = rightTextOverlays[n];
      const time = {
        leftDuration: originalAsset.displayDuration,
        rightDuration: cloneAsset.displayDuration,
        cut: originalAsset.displayDuration,
        start: app.sfp(left.animationStartTime * assetSplitTimes.oldDuration),
        end: app.sfp(left.animationEndTime * assetSplitTimes.oldDuration),
      };

      const isBeforeCut = time.end <= time.cut;
      const isAfterCut = time.start >= time.cut;
      const isAtCut = !isBeforeCut && !isAfterCut;

      if (isBeforeCut) {
        // update times of left one
        left.animationStartTime = app.sfp(time.start / time.leftDuration);
        left.animationEndTime = app.sfp(time.end / time.leftDuration);

        // mark for delete from right asset
        right._REMOVED_ = true;
      } else if (isAfterCut) {
        // mark for delete from left asset
        left._REMOVED_ = true;

        // update times of right one
        right.animationStartTime = app.sfp(
          (time.start - time.cut) / time.rightDuration
        );
        right.animationEndTime = app.sfp(
          (time.end - time.cut) / time.rightDuration
        );
      } else if (isAtCut) {
        // for left asset
        left.animationStartTime = app.sfp(time.start / time.leftDuration);
        left.animationEndTime = 1;
        const leftToDuration = app.sfp(time.cut - time.start);
        if (leftToDuration < app.TIME.MIN_FREE_TEXT_DURATION) {
          left._REMOVED_ = true;
        }

        // for right asset
        right.animationStartTime = 0;
        right.animationEndTime = app.sfp(
          (time.end - time.cut) / time.rightDuration
        );
        const rightToDuration = app.sfp(time.end - time.cut);
        if (rightToDuration < app.TIME.MIN_FREE_TEXT_DURATION) {
          right._REMOVED_ = true;
        }

        // disable animation for sliced  TOT
        left.animationOutId = app.ANIMATION.NONE.id;
        right.animationId = left.animationOutId;

        // in case "out" is abstract
        if (
          !right.animationOutId ||
          right.animationOutId === app.ANIMATION.CONTINUE.id
        ) {
          // lookup in allIn by left.animationId to get anim.continueId to use as out
          const allIn = app.rootStore.state.story.themeInfo.animationPresets;
          const animIn = _.find(allIn, { id: left.animationId });
          if (animIn) {
            right.animationOutId = animIn.continueId;
          } else {
            right.animationOutId = app.ANIMATION.CONTINUE.id;
          }
        }
      }
    });

    // filter-out marked for deletion text overlays
    _.each([originalAsset, cloneAsset], (asset) => {
      const textOverlays = asset.agd && asset.agd.textOverlays;
      if (textOverlays) {
        asset.agd.textOverlays = _.filter(textOverlays, (to) => !to._REMOVED_);
      }
    });
  }
}
